import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { postClientLog } from './utils/clientLog'

// Fase 3 — Telemetria do frontend. Captura erros globais que escapam do
// ErrorBoundary (event handlers, código fora do React, promises rejeitadas
// sem catch). Envia pro backend via fetch puro (helper silencioso —
// nunca quebra a UI). Auth obrigatória — sem token, helper aborta cedo.
window.addEventListener('error', (event) => {
  postClientLog({
    level: 'error',
    message: event.message || 'Error',
    stack: event.error?.stack,
    extra: {
      source: 'window.onerror',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    },
  })
})

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  const message = typeof reason === 'string'
    ? reason
    : (reason?.message ?? String(reason ?? 'Unhandled rejection'))
  postClientLog({
    level: 'error',
    message,
    stack: reason?.stack,
    extra: { source: 'unhandledrejection' },
  })
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

